import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    product: null,
    products: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const productReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.PRODUCT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.PRODUCT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.PRODUCT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.PRODUCT_RESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default productReducer;
